import React from 'react'
import PopoverTooltip from '../shared/PopoverTooltip'

export default function SidebarCardHeader({ label, date, time, tooltip }) {
  const hasSubline = date || time

  return (
    <div className="sidebar-card-header dome-d-flex dome-align-center">
      <span className="sidebar-card-header__label">{label}</span>
      {hasSubline ? (
        <span className="sidebar-card-header__subline dome-d-flex dome-align-center dome-gap6">
          {date && <span className="sidebar-card-header__date">{date}</span>}
          {time && <span className="sidebar-card-header__time">{time}</span>}
          {time && <span className="sidebar-card-header__timezone">ET</span>}
          {tooltip && (
            <PopoverTooltip content={tooltip} className='sidebar-card-header_tooltip'>
              <i className='fal fa-circle-question dome-p3' />
            </PopoverTooltip>
          )}
        </span>
      ) : (
        tooltip && (
          <PopoverTooltip content={tooltip} className='sidebar-card-header_tooltip'>
            <i className='fal fa-circle-question dome-p3' />
          </PopoverTooltip>
        )
      )}
    </div>
  )
}
